import {
  ActionIcon,
  Group,
  MultiSelect,
  MultiSelectProps,
  Select,
  SelectProps,
  Tooltip,
} from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

import { useGetManyMedicalDoctorsQuery } from '@api/medicalDoctors.api';

type MedicalDoctorsSelectorProps =
  | (Omit<
      SelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple?: false;
    })
  | (Omit<
      MultiSelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple: true;
    });

export default function MedicalDoctorsSelector(
  props: MedicalDoctorsSelectorProps,
) {
  // ==========================================================================
  // Api
  // ==========================================================================
  const {
    data = [],
    isLoading,
    refetch,
  } = useGetManyMedicalDoctorsQuery({
    sortBy: 'user.name',
    sortOrder: 'asc',
  });

  // ==========================================================================
  // Render
  // ==========================================================================
  return props.multiple ? (
    <MultiSelect
      {...props}
      label={
        <Group
          display="inline-flex"
          w="max-content"
          gap="0.2rem"
          align="center"
        >
          <Tooltip label="Ricarica opzioni">
            <ActionIcon size="1rem" variant="subtle" onClick={refetch}>
              <IconRefresh />
            </ActionIcon>
          </Tooltip>
          <span>{props.label}</span>
        </Group>
      }
      searchable
      nothingFoundMessage="Nessun medico trovato"
      placeholder={
        props.value?.length || 0 > 0 ? undefined : 'Seleziona il medico'
      }
      data={data.map((doctor) => ({
        value: doctor.id,
        label: doctor.user.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  ) : (
    <Select
      {...props}
      label={
        <Group
          display="inline-flex"
          w="max-content"
          gap="0.2rem"
          align="center"
        >
          <Tooltip label="Ricarica opzioni">
            <ActionIcon size="1rem" variant="subtle" onClick={refetch}>
              <IconRefresh />
            </ActionIcon>
          </Tooltip>
          <span>{props.label}</span>
        </Group>
      }
      searchable
      nothingFoundMessage="Nessun medico trovato"
      placeholder="Seleziona il medico"
      data={data.map((doctor) => ({
        value: doctor.id,
        label: doctor.user.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  );
}
